import { IPwaPreviewConfig } from '@adminPortal/_common/_interfaces/IPwaPreviewConfig';
import { AsyncPipe } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppService } from '@pwaPortal/core/services/app/app.service';
import { DataProviderService } from '@pwaPortal/core/services/data-provider/data-provider.service';
import { HelperService } from '@pwaPortal/core/services/helper/helper.service';
import { PwaProcessService } from '@pwaPortal/core/services/pwa-process/pwa-process.service';
import { LpComponent } from '@pwaPortal/pages/lp/lp.component';
import { PwaComponent } from '@pwaPortal/pages/pwa/pwa.component';
import { Observable, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  imports: [LpComponent, PwaComponent, AsyncPipe],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnDestroy {
  private dataProviderService = inject(DataProviderService);

  public ready$: Observable<boolean>;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  public lpConfig!: IPwaPreviewConfig;
  public isPwaMode: boolean = false;

  constructor(
    private appService: AppService,
    protected helperService: HelperService
  ) {
    this.ready$ = this.appService.appReady;
    this.ready$
      .pipe(
        takeUntil(this.destroy$),
        filter((isReady) => isReady)
      )
      .subscribe(() => {
        // starting rendering only after appService fully initialised, including db and all necessary preparations
        this.init();
      });
  }

  async init() {
    this.lpConfig = await this.helperService.getPwaConfig();
    this.isPwaMode = this.helperService.getIsPwaMode();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
